import { EChartsOption } from "echarts-for-react";

export interface DeepInsightSummary {
  id: string;
  chip: string;
  category: string;
  title: string;
  description: string;
  date: string;
  isPinned: boolean;
  isArchived: boolean;
}

export interface DomoCollection {
  id: string;
  datastoreId: string;
  defaultPermissions: unknown;
  requiredAuthorities: unknown;
  owner: number;
  name: string;
  datasourceId: unknown;
  filters: unknown;
  syncEnabled: boolean;
  syncRequired: boolean;
  fullReplaceRequired: boolean;
  lastSync: unknown;
  createdOn: string;
  updatedOn: string;
  updatedBy: number;
}

export interface DeepInsightDocumentContent {
  id: string;
  runId: string;
  crossTabulationId: string;
  crossTabulationName: string;
  title: string;
  summary: string;
  pillar?: string;
  sectionsJSONString: string;
  chartJSONString?: string;
  relevantHistoricalDatesJSONString?: string;
  sections: DeepInsightSection[];
  chart?: EChartsOption;
  priority: string;
  rank: number;
  isValid: number;
  version: number;
  updatedBy: string;
  updateDateTime: number;
}

export interface DeepInsightSection {
  title: string;
  content: string;
  data: unknown | null;
}

export interface DeepInsightWithContent {
  id: string;
  chip: string;
  category: string;
  content: DeepInsightDocumentContent;
}

export type DeepInsightsEnabled =
  | { enabled: false }
  | {
      enabled: true;
      collection: DomoCollection;
    };

export const DEEP_INSIGHT_CHAT_CONTEXT_PREFIX =
  "Please review the following context carefully:\n```json\n";
export const DEEP_INSIGHT_CHAT_CONTEXT_SUFFIX =
  "\n```\nNow, using this context, answer the following question:\n\n";
